<div style="overflow-y:auto; height: 70px;" *ngIf="DashboarddataList.length > 0">
  <div *ngFor="let Value of DashboarddataList[Index].MeterValuesList; index as i">
    <div class="card-data card-data-right-align" id="{{ 'card-data' + i }}">
      <div class="card-inner-data">

        <!-- <span class="dashbrdlbl-inner-span" *ngIf="lstdashboard.MeterValueLable[i]"></span> -->
        <p class="dashbrdlbl-inner-span text-none" *ngIf="Value != 'No data found'"> <span
            class="unit-data word-wrap">{{Value}}</span>
            <!-- <span class="span-space"></span> -->
        </p>
      </div>
    </div>
  </div>
</div>